import React from 'react'
import { connect } from 'react-redux'
import { TextField } from 'redux-form-material-ui'
import { Field } from 'redux-form'
import { missionPEField } from '../../../../../../utils/constants'


class TextAreaElement extends React.Component {

  required = value => value == null ? 'Requerido' : undefined

  render() {
    const { element, real_answer } = this.props
    if (real_answer) {
      return (
        <TextField
          id={real_answer.page_element_id}
          value={real_answer.answer_text}
          multiLine
          rows={4}
          rowsMax={8}
        />
      )
    }
    return (
      <Field
        name={missionPEField(element)}
        floatingLabelText="Escribe tu respuesta aquí"
        component={TextField} fullWidth type="text"
        multiLine
        validate={element.required === true ? this.required : () => undefined }
        rows={4}
        rowsMax={8}
      />
    )
  }

}

TextAreaElement.propTypes = {
  element: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(TextAreaElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/TextAreaElement/index.jsx